/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayByPlayModelDto } from '../../models/play-by-play-model-dto';

export interface GameTrackerControllerCreateGamePbp$Params {
  uuid: string;
      body: PlayByPlayModelDto
}

export function gameTrackerControllerCreateGamePbp(http: HttpClient, rootUrl: string, params: GameTrackerControllerCreateGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerControllerCreateGamePbp.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayByPlayModelDto>;
    })
  );
}

gameTrackerControllerCreateGamePbp.PATH = '/game-tracker/games/{uuid}/pbp';
